import React from 'react';

const Success = () => {
  
  return (
    <div className="d-flex flex-column justify-content-center align-items-center mt-4" style={{ height: '80vh' }}>
      <i className="bi bi-check-circle text-success" style={{ fontSize: 36 }}></i>
      <p className="px-3 text-center text-light fw-normal mb-0" style={{ fontSize: 20 }}>  
        Card linked successfully!
      </p>
    </div>
  );
};

export default Success;